export default __webpack_public_path__ + "static/media/login page video.bff52a92.mp4";